import React from 'react'
import PropTypes from 'prop-types'

import { SiteContext } from 'context/site-context'

import {
  formatPhoneNumber,
  getAddress,
  getQS,
} from 'helpers'

import './index.scss'

const BannerAd = props => {
  const [ site ] = React.useContext(SiteContext)

  const {
    result,
    city,
  } = props

  const getLogo = (logoUrl, name) => {
    return logoUrl ? <div className="logo-container"><img src={logoUrl} alt={name} /></div> : null
  }

  const getProfileUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/` : ''}profile/${result.id}${qs}`
  }

  return <div className="banner-container">
    <a href={getProfileUrl()}>{getLogo(result.image, result.name)}</a>
    <div className="details-container">
      <a href={getProfileUrl()}><h4 className="business-name">{result.name}</h4></a>
      <div className="address">{getAddress(result.address)} {result.address?.postal_code || ''}</div>
    </div>
    <div className="actions-container">
      <a href={`tel:${result.phone_number}`} className="button-trigger">{formatPhoneNumber(result.phone_number)}</a>
    </div>
  </div>
}

BannerAd.propTypes = {
  result: PropTypes.object.isRequired,
}

export default BannerAd
